import { Turbo } from "@hotwired/turbo-rails";

import { iframeResizer } from "iframe-resizer";
import "../tailwind/application.css";

// import "../application/availability.js";
import "../application/community_ticker.js";
import "../application/cookie_consent.js";
import "../application/datepicker.js";
import "../application/diffhtml.js";
import "../application/drawer.js";
import "../application/favorites.js";
import "../application/host_offer_delete.js";
import "../application/host_offer_duplicate.js";
import "../application/host_offer_order.js";
import "../application/host_offer_form.js";
import "../application/host_offer_visibility.js";
import "../application/host_tabs.js";
import "../application/host_offers_scroll.js";
import "../application/membership_drawer.js";
import "../application/profile.js";
import "../application/password_visibility.js";
import "../application/profile_global_notice.js";
import "../application/user_menu.js";
import "../application/newsletter_notice.js";
import "../application/offers_filter.js";
import "../application/pinterest.js";
import "../application/preflight.js";
import "../application/search.js";
import "../application/toggle_fixed.js";
import "../application/trigger.js";
import "../application/analytics.js";

Turbo.start();

function renderTurnstileWidgets() {
  if (typeof turnstile === "undefined") return;

  document.querySelectorAll(".cf-turnstile").forEach(function (el) {
    if (el.querySelector("iframe")) return;

    turnstile.render(el, {
      sitekey: el.dataset.sitekey,
      callback: function () {
        var btn = document.getElementById("suggestion-submit");
        if (btn) btn.disabled = false;
      },
    });
  });
}

// The Turnstile script is loaded async; on a cold page load it is usually not ready yet at
// turbo:load, so Cloudflare calls this once the script has finished loading (see layout).
window.onloadTurnstileCallback = renderTurnstileWidgets;

$(document).on("turbo:load", function () {
  iframeResizer(document.querySelectorAll("#iframe-container"));
  renderTurnstileWidgets();
});

$(document).on("turbo:frame-load", function () {
  renderTurnstileWidgets();
});
